export default customElements.define('w-readonly-field', class ReadonlyField extends wealthify.CustomElementBaseClass {

    constructor () {
        const styleSelector = 'c-readonly-field';
        const config = {
            styleSelector, 
            templateHTML: `
                <div class="${styleSelector}__container" data-root>
                    <p class="${styleSelector}__label" data-label></p>
                    <p class="${styleSelector}__value" data-value></p>
                </div>`,
            cacheDom: [ 'data-label', 'data-value' ]
        };

        super(config);

        this.onConnectedCallback = () => {  
            this.classList.add(this.styleSelector);
        };
    }

    static get observedProps () {
        return [

            new wealthify.Prop('label', {required: true}),

            new wealthify.Prop('value', {required: true}),

            new wealthify.Prop('showlast')
        
        ];
    }

    get propCallbacks() {
        return {   
                        
            label: (value) => {
                this.dom.label.innerHTML = value;    
            },

            value: (value) => {
                this.dom.value.innerHTML = value;    
            },

            showlast: (value) => {
                
                const len = this.value.length;

                if(len > value){

                    let obfuscated = '*'.repeat(len - value);

                    obfuscated += this.value.slice(-value);
                    this.dom.value.innerHTML = obfuscated;
                }
            }

        };
    }
});